var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComboComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 50 50",
    height: 512,
    viewBox: "0 0 50 50",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.2626 33.3864-6.01 3.491c.0021-.6352-.4433-1.4109-.9974-1.7306l-7.5637-4.3668c-.2792-.1598-.5307-.1769-.7139-.0703l6.0079-3.4909c.1833-.1066.4348-.0916.7139.0703l7.5637 4.3669c.5541.3196.9995 1.0932.9995 1.7304z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.2552 35.1472c.5538.3197 1 1.0941.9982 1.7305l-9.5685-5.5244c.0018-.6364.4523-.8931 1.0061-.5733z",
    fill: "#373f51"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48.9558 34.8604-.0088 2.541c0 .3972-.1412.6708-.3618.8031l-1.2441.7238c.2206-.1327.3617-.4058.3617-.8031l.0088-2.541z",
    fill: "#b4bed7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.713 19.4226 1.2437-.7228 27.9982 16.1647-1.2438.7228z",
    fill: "#b4bed7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47.7111 35.5873-.0072 2.5374c-.0022.7898-.5618 1.1151-1.2547.715l-25.4969-14.7206c-.6929-.4001-1.2488-1.3693-1.2465-2.1591l.0072-2.5374z",
    fill: "#d3dbea"
  }))), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m49 18.0521-.0442 16.8084-1.2441.7238.0441-16.8088c0-.794-.5559-1.7647-1.2441-2.1615l-25.4995-14.7176c-.3529-.2029-.6618-.2206-.8912-.0883l1.2441-.7234c.2294-.1323.5382-.1146.8912.0883l25.4996 14.7171c.6882.3973 1.2441 1.3679 1.2441 2.162z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.5085 16.6141c.6929.4001 1.2488 1.363 1.2466 2.1591l-.0439 16.8141-27.9982-16.1647.0439-16.8141c.0023-.7962.5618-1.1151 1.2547-.715z",
    fill: "#373f51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.6402 2.6972-.044 17.2334 26.2367 15.1479.0422-17.2339z",
    fill: "#fe91ab"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.1777 34.4015-.0021.7383-1.3641-.7876.0021-.7382z",
    fill: "#9da9c1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44.1667 35.5498-.0021.7383-1.3641-.7875.0021-.7383z",
    fill: "#9da9c1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.1557 36.6982-.0021.7383-1.3641-.7876.002-.7383z",
    fill: "#9da9c1"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1 32.1127.0027.9902c0 .0581.0211.1006.0554.1187l27.129 15.7671c-.0343-.0215-.0554-.0635-.0554-.1216l-.0027-.9902c0-.0542.0214-.1133.0501-.1675l-27.1286-15.7666c-.0291.0546-.0505.1142-.0505.1699z",
    fill: "#9da9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.5408 44.536 2.7385 1.5923-.7421-1.3208-1.228-.7129 3.0977-1.79c.0529-.0293.1004-.0317.1347-.0137l-27.129-15.7637c-.0344-.0215-.0818-.0161-.1347.0127l-9.0905 5.248c-.0558.0327-.1025.0903-.137.1548l27.1285 15.7666c.0344-.0649.0812-.123.1374-.1548z",
    fill: "#b4bed7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37.4073 42.3055c.1029-.0594.1874-.0131.1878.107l.0028.9901c.0003.1181-.0837.2637-.1865.3231l-.5008.2891.0049 1.7456-.6373.368-.7401-1.3212-7.2181 4.1674c-.1029.0594-.1874.0111-.1878-.107l-.0028-.9901c-.0003-.1201.0837-.2637.1865-.3231z",
    fill: "#4c5671"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.8958 28.2903-1.1659.6776-1.2357-.7134 1.166-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.5618 29.2522-1.1659.6775-1.2357-.7134 1.166-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.2278 30.214-1.166.6776-1.2378-.7147 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.8938 31.1759-1.166.6775-1.2445-.7185 1.166-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.0469 29.5032-1.1659.6776-1.8568-1.0721 1.166-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.7129 30.465-1.1659.6776-1.2423-.7172 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.3789 31.4269-1.1659.6776-1.2423-.7173 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.0449 32.3887-1.166.6776-1.2422-.7172 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.5597 32.1377-1.1659.6776-1.2445-.7185 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.7109 33.3506-1.166.6776-1.2445-.7185 1.166-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.6217 30.9608-1.1659.6775-2.9016-1.6753 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.2876 31.9226-1.1658.6775-1.2423-.7172 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.9536 32.8845-1.1658.6775-1.2445-.7185 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.6196 33.8463-1.1658.6775-1.2445-.7185 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.5732 32.0609-1.1637.6763-3.3253-1.9199 1.1637-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.237 33.0215-1.1637.6762-1.2356-.7133 1.1636-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.8209 33.936-1.1637.6762-1.2423-.7172 1.1637-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.4026 34.8492-1.1637.6762-1.2423-.7172 1.1637-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.2235 33.0983-1.1659.6776-1.2423-.7173 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.3768 34.3125-1.1659.6775-1.2445-.7185 1.166-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.2834 34.8069-1.1659.6775-1.2422-.7172 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.982 35.7611-1.1636.6762-1.2423-.7172 1.1636-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.8895 34.0602-1.1659.6775-1.2423-.7172 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.5555 35.022-1.166.6776-1.2422-.7173 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.2215 35.9839-1.166.6775-1.2423-.7172 1.166-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.8874 36.9457-1.1659.6776-1.2423-.7172 1.166-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.5534 37.9076-1.1659.6775-1.2423-.7172 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.0406 35.273-1.1659.6776-1.2423-.7172 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.7066 36.2349-1.1659.6776-1.2423-.7173 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.0834 38.7618-1.1659.6776-3.9531-2.2823 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.9494 35.7688-1.1659.6775-1.2422-.7173 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.6153 36.7306-1.1658.6775-1.2423-.7172 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.2813 37.6925-1.1658.6775-1.2423-.7173 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.6133 39.6162-1.1658.6775-2.9083-1.6791 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.4751 39.5099-1.1636.6762-1.2423-.7172 1.1637-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.5637 36.6742-1.1637.6763-1.2444-.7185 1.1636-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.1432 37.5861-1.1637.6763-1.2423-.7172 1.1637-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.0135 31.7087-1.1637.6763-1.2422-.7173 1.1636-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.6795 32.6706-1.1637.6762-1.2422-.7172 1.1636-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.3455 33.6324-1.1637.6763-1.2423-.7173 1.1637-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.0782 37.5195-1.1637.6763-6.3112-3.6438 1.1637-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.6732 38.4404-1.1637.6763-1.2423-.7173 1.1637-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.3392 39.4023-1.1637.6762-1.2423-.7172 1.1637-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.0051 40.3641-1.1636.6763-1.2423-.7172 1.1637-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.6711 41.326-1.1636.6762-1.2423-.7172 1.1636-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m29.1749 42.2498-1.1658.6775-1.2445-.7185 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.4491 39.5794-1.166.6775-1.2445-.7185 1.166-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.979 40.4336-1.1659.6776-1.2445-.7185 1.166-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.5089 41.288-1.1658.6775-1.2445-.7185 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.0368 42.1435-1.1637.6763-1.2445-.7186 1.1637-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.115 40.5412-1.1659.6776-1.2445-.7185 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.645 41.3955-1.1659.6776-1.2445-.7185 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.7027 43.1054-1.1636.6762-1.2445-.7185 1.1637-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.2327 43.9596-1.1636.6763-2.9105-1.6804 1.1637-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.7721 41.498-1.1659.6775-1.2356-.7134 1.1659-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35.4381 42.4598-1.1659.6776-1.2356-.7134 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.3021 42.3522-1.1659.6776-1.2356-.7134 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.832 43.2066-1.1658.6775-1.2356-.7134 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m29.3599 44.0621-1.1637.6762-1.2356-.7133 1.1636-.6763z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.8898 44.9164-1.1636.6762-1.2356-.7134 1.1636-.6762z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.9681 43.3141-1.1659.6776-1.2356-.7134 1.1659-.6776z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.498 44.1684-1.1658.6775-1.2356-.7134 1.1658-.6775z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.0258 45.024-2.6336 1.5305-1.2357-.7134 2.6337-1.5305z",
    fill: "#4c5671"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37.8361 40.2566c.131.2269-.0625.362-.2081.1186-.2614-.4527-.8971-1.0306-1.344-.776-.0741.0352-.1645-.0495-.2074-.1198-.0553-.0986-.055-.2066.0007-.2384.6133-.3404 1.4057.4039 1.7588 1.0156z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m38.6667 39.5558c.0553.0958.055.2031-.0007.2349-.0722.0411-.1665-.0463-.2074-.1198-.5995-1.0352-1.9677-2.3135-2.9985-1.7312-.0732.0416-.1653-.0468-.2074-.1198-.0553-.0959-.055-.2031.0007-.2349 1.1737-.6679 2.732.7912 3.4133 1.9708z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m38.2502 39.9037c.0584.1011.0581.2056-.0007.2384-.0691.0394-.1649-.0489-.205-.1184-.4375-.7577-1.4304-1.6792-2.1713-1.2536-.0714.0424-.1653-.0467-.2074-.1198-.0578-.1001-.0575-.2045.0007-.2383.8892-.5058 2.0676.5982 2.5837 1.4917z",
    fill: "#4c5671"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.9556 40.2327c.2392.1381.4344.4727.4336.7517-.0008.2748-.1973.3868-.4364.2487-.2428-.1402-.435-.4765-.4342-.7513.0008-.279.1942-.3893.437-.2491z",
    fill: "#4c5671"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboComputer);
export default __webpack_public_path__ + "static/media/combo-computer.ca710e26ed5f2a66a3cff4de774c5681.svg";
export { ForwardRef as ReactComponent };